import { cn } from "../../../classNames-DcGnTh2N.js";
import { useId } from "react";
import { Fragment as Fragment$1, jsx } from "react/jsx-runtime";
//#region src/components/Skeleton/Skeleton.tsx
const HEIGHT_CLASS_NAME = {
	xxs: "tw:h-3 tw:rounded",
	xs: "tw:h-4 tw:rounded",
	sm: "tw:h-5 tw:rounded",
	md: "tw:h-6 tw:rounded-md",
	lg: "tw:h-8 tw:rounded-lg",
	xl: "tw:h-10 tw:rounded-lg",
	"2xl": "tw:h-12 tw:rounded-lg"
};
const ANIMATION_CLASS_NAME = cn("tw:relative", "tw:overflow-hidden", "tw:pointer-events-none", "tw:bg-skeleton", "tw:before:content-[\"\"]", "tw:before:opacity-100", "tw:before:absolute", "tw:before:inset-0", "tw:before:-translate-x-full", "tw:before:animate-[shimmer_2s_infinite]", "tw:before:bg-gradient-to-r", "tw:before:from-transparent", "tw:before:to-transparent", "tw:before:via-white/40", "tw:[[data-theme=dark]_&]:before:via-white/10");
/**
* Placeholder in the slot of loading content.
*
* - Match the eventual shape (`lg` per title row, `xs` per text line).
* - Not for slotless work (`DotsLoader`, `Button isLoading`) or empty / error states.
* - `Table.SkeletonRows` fills a loading `Table`; `SkeletonList` shells `Card`-list pages.
*
* @see RECIPES.md#data-card-with-skeleton
*/
const Skeleton = ({ height = "md", className, count = 1 }) => {
	const prefixId = useId();
	const keys = Array.from({ length: count }, (_, i) => `${prefixId}-${i}`);
	return /* @__PURE__ */ jsx(Fragment$1, { children: keys.map((key) => /* @__PURE__ */ jsx("div", {
		"data-skeleton": "true",
		className: cn(HEIGHT_CLASS_NAME[height], ANIMATION_CLASS_NAME, className)
	}, key)) });
};
//#endregion
export { Skeleton };

//# sourceMappingURL=Skeleton.js.map